// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ":host{display:block}#base{width:100%;height:100%;background-position:var(--background-position, center);background-size:var(--background-size, cover);background-attachment:var(--background-attachment);background-repeat:no-repeat}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
